// /client/src/components/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import NavigationPublic from './NavigationPublic';

const Login = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { login, isAuthenticated } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // Check for logout success message and redirect if authenticated
  useEffect(() => {
    // Show logout success message if present in URL params
    if (searchParams.get('logout') === 'success') {
      setSuccessMessage('You have been successfully logged out.');
      
      // Remove the logout parameter from URL
      searchParams.delete('logout');
      setSearchParams(searchParams, { replace: true });
      
      // Auto-dismiss the message after 5 seconds
      const timer = setTimeout(() => {
        setSuccessMessage('');
      }, 5000);
      
      return () => clearTimeout(timer);
    }

    // Redirect if already authenticated
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate, searchParams, setSearchParams]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccessMessage(''); // Clear any logout messages when attempting login

    try {
      const response = await axios.post('/api/auth/login', formData);
      
      // Use the auth context login method instead of directly setting localStorage
      login(response.data.user, response.data.token);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="m-0 p-0 hero is-fullheight">
      <NavigationPublic />
      <div className="m-0 p-0 is-flex is-flex-direction-column hero-body"> 
        <div className="m-0 p-0 container">
          <div className="mb-6 pb-6 columns is-centered">
            <div className="mb-6 pb-6 column is-5-tablet is-4-desktop is-5-widescreen">
              <form onSubmit={handleSubmit} className="m-4 p-6 box borderRadius backgroundColorGrey">
                <h1 className="pb-3 h1 colorBlack is-bold">Login</h1>
                
                {successMessage && (
                  <div className="notification is-success is-light">
                    <button 
                      className="delete" 
                      onClick={() => setSuccessMessage('')}
                    ></button>
                    {successMessage}
                  </div>
                )}

                {error && (
                  <div className="notification backgroundColorError">
                    <button 
                      className="delete" 
                      onClick={() => setError('')}
                    ></button>
                    {error}
                  </div>
                )}

                <div className="field">
                  <label className="m-0 p-0 label">Email</label>
                  <div className="m-0 p-0 control">
                    <input
                      className="input"
                      type="email"
                      name="email"
                      placeholder="your@email.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="m-0 p-0 label">Password</label>
                  <div className="m-0 p-0 control">
                    <input
                      className="input"
                      type="password"
                      name="password"
                      placeholder="********"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* <div className="field">
                  <div className="control">
                    <label className="checkbox colorBlack">
                      <input type="checkbox" />
                      {' '}Remember me
                    </label>
                  </div>
                </div> */}

                <div className="pt-5 field">
                  <button 
                    className={`button is-fullwidth ${loading ? 'is-loading' : ''}`}
                    type="submit"
                    disabled={loading}
                  >
                    Login
                  </button>
                </div>
              </form>

              <div className='is-flex is-justify-content-center'>
                <p className='is-bold psmall'>
                  <a href="/reset-password">Forgot password?</a>
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;